var doc = $(document),
    win = $(window),
    html = $("html"),
    body = $("body"),
    lang = html.attr('lang');

function fn_layout_main() {
    $("body").removeClass("mod--preload");
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    fn_scrollreveal();
    fn_nl_lib_anchor();

    var $parallax = $(".lib--parallax").find("img:not(.lazyload)");
    if ($parallax.length) {
        $parallax.parent().parallax();
    }

    $(document).on('lazybeforeunveil', function (e) {
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });

    if ($("[data-masonry-grid]").length) {
        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/masonry/4.1.1/masonry.pkgd.min.js").done(function () {
            $("[data-masonry-grid]").masonry({
                itemSelector: '.col',
                columnWidth: '.col',
                percentPosition: true
            })
        });
    }

    nl_lib_dialog.init();

    $(document).on("click", "[data-print]", function() {
        printJS($(this).data("print"));
    });

    if ((navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) || ((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) && (parseInt(navigator.userAgent.substring(navigator.userAgent.indexOf("Version") + 8)) < 10))) {
        $("body").addClass("mod--ie");
        function resize_svg() {
            setTimeout(function () {
                $("svg").each(function () {
                    if ($(this).filter("[data-width]").length) {
                        var $width_original = $(this).data("width"),
                                $height_original = $(this).data("height"),
                                $width = $(this).parent().innerWidth(),
                                $ratio;

                        $ratio = $width / $width_original;
                        $(this).css("height", $height_original * $ratio);
                    }
                });
            }, 100);
        }
        resize_svg();
        $(window).resize(resize_svg);
    }

    var picture = document.createElement('picture'),
            strObj = '' + picture;
    if (strObj.indexOf("HTMLPictureElement") == -1 && $(window).width() < 1023)
    {
        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.2/picturefill.min.js");
    }
}


$(document).on('click', 'ul.wrp_content_nav li a.ajax', function (e) {
    e.preventDefault();
    $('ul.wrp_content_nav li a').removeClass('mod--active');
    $(this).addClass('mod--active');



});

/* AJAX filter */
$(document).on('change', '.elm_filter_inner input', function (e) {
    e.preventDefault();
    var ajaxData = $('.elm_filter_inner').serialize();
    $.ajax({
        url: location.protocol + '//' + location.host + location.pathname,
        data: ajaxData
    }).done(function () {
        window.history.pushState("", "", decodeURIComponent('?' + ajaxData));//ok
    });
});

/* AJAX FORM */
$(document).on('submit', 'form.ajax', function (e) {
    e.preventDefault();
    var $frm = $(this);
    console.log($frm);
    $.ajax({
        method: $frm.attr('method'),
        url: $frm.attr('action'),
        data: $frm.serialize()
    });
});

/* AJAX LINKS*/
$(document).on('click', 'a.ajax', function (e) {
    e.preventDefault();
    var $el = $(this);
    $.ajax({
        url: $el.attr('href')
    }).done(function () {
        window.history.pushState("", "", $el.attr('href'));
        fn_libs_reload();
    });
});

/* GLOBAL AJAX EVENT HANDLER */
$.ajaxSetup({
    success: function (payload) {
        if (payload) {
            if (payload.alert) {
                alert(payload.alert);
            }
            if (payload.redirect) {
                if (payload.redirect == 'this') {
                    location.href = window.location.href.split("#")[0];
                } else {
                    location.href = payload.redirect;
                }
            }
            if (payload.snippets) {
                for (var i in payload.snippets) {
                    $("#" + i).replaceWith(payload.snippets[i]);
                }
            }
            if (payload.replaceState) {
                window.history.replaceState(null, null, payload.replaceState.url);
                //document.title = payload.replaceState.title;
            }
        }
    },
    dataType: "json"
});